<div class="testimonial-card" [class.active]="isActive">
  <div class="image-wrapper">
    <img
      [src]="testimonial.image"
      [alt]="testimonial.name"
      [title]="testimonial.name"
      loading="lazy"
    />
  </div>

  <div class="content">
    <h4 class="name">{{ testimonial.name }}</h4>
    <span class="role">{{ testimonial.role }}</span>

    <p class="text">"{{ testimonial.text }}"</p>

    <div class="rating">
      <span *ngFor="let star of stars" class="star" [class.filled]="star === 1">★</span>
    </div>
  </div>
</div>
